import { render } from "./textElement.vue?vue&type=template&id=fed4c988"
import script from "./textElement.vue?vue&type=script&lang=js"
export * from "./textElement.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__